import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CitiesListType } from '../types';

type InitialStateType = {
  data: CitiesListType[];
};

const initialState: InitialStateType = {
  data: [],
};

const citiesSlice = createSlice({
  name: 'cities',
  initialState,
  reducers: {
    setCitiesData(state, action: PayloadAction<CitiesListType[]>) {
      state.data = action.payload;
    },
  },
});

export const { setCitiesData } = citiesSlice.actions;

export { citiesSlice };
